/**
 * Demo configuration for quick user switcher and exhibition controls
 */
export const DEMO_CONFIG = {
  enabled: import.meta.env.VITE_DEMO_MODE !== 'false',
  users: [
    { id: 1, role: 'principal', name: 'Dr. Anand Verma', subtitle: 'Principal / Admin', defaultRoute: '/principal/overview' },
    { id: 2, role: 'teacher', name: 'Sunita Rao', subtitle: 'Class Teacher (6-A)', defaultRoute: '/teacher/today' },
    { id: 10, role: 'student', name: 'Aarav Sharma', subtitle: 'Student (6-A #1)', defaultRoute: '/student/home' },
    { id: 70, role: 'parent', name: 'Vikram Sharma', subtitle: 'Parent (Aarav)', defaultRoute: '/parent/home' }
  ]
};
